import React from 'react';
import { useParams } from 'react-router-dom';
import { ItemDetail } from '../../components/ItemDetail/ItemDetail';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import BubbleContainer from 'components/BubbleContainer/BubbleContainer';
import { useUserData } from 'services/UserService';

type ItemDetailPageParams = Record<'id', string>;

export function ItemDetailPage() {
  const { id } = useParams<ItemDetailPageParams>();
  const { data: userData } = useUserData();

  useDocumentTitle('Item Details');

  if (!id) {
    return <div>Invalid item ID</div>;
  }

  return (
    <div>
      <ItemDetail itemId={id} type="item" currentUserId={userData?.id} />
      <BubbleContainer />
    </div>
  );
}
